import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

import { Checkbox, Chip, Tooltip } from '@material-ui/core'

import { Edit, EventAvailable } from '@material-ui/icons'

function MuralListItem({
  item,
  showGroups,
  handleCheckUnit,
  setShowPostModal,
  setToBeDeleted,
  classes,
  checked
}) {
  const secheduled = moment(item?.publishedDate)
  const isPublished = moment().isBefore(secheduled)
  return (
    <tr key={item.id}>
      {console.log(item)}
      <td>
        <Checkbox
          value={item.id}
          checked={checked.includes(item.id)}
          onChange={() => handleCheckUnit(item.id)}
          color="primary"
        />
      </td>
      <td>
        <div className="wrapper-post-title">
          <div className="post-title">
            {item.title}{' '}
            {item.situation === 3 && (
              <Tooltip title="Rascunho">
                <Edit fontSize="small" />
              </Tooltip>
            )}
            {!!item.publishedDate && isPublished ? (
              <Tooltip title="Agendado">
                <EventAvailable fontSize="small" />
              </Tooltip>
            ) : (
              ''
            )}
          </div>
          <div>
            <Link to={{ pathname: '/muralform', state: item }} className="link-edit">
              Editar
            </Link>
            | <a onClick={() => setShowPostModal(item)}>Visualizar</a>|
            <a className="link-delete" onClick={setToBeDeleted(item)}>
              Excluir
            </a>
          </div>
        </div>
      </td>
      <td>{item.User?.name || 'Clube Gazeta'}</td>
      {!showGroups && (
        <td>
          {item.clubeApp ? <span>Clube Gazeta</span> : null}
          {item.WhiteLabelMuralWhiteLabelLists?.map(group => (
            <span key={group.id}>{group.WhiteLabel?.title}</span>
          ))}
        </td>
      )}

      <td>
        {item.publishedDate
          ? moment(item.publishedDate).format('L [às] LT')
          : moment(item.createdAt).format('L [às] LT')}
      </td>
      <td>{!!item.featured && <Chip className={classes.chip} label="Destaque" />}</td>
    </tr>
  )
}

export default MuralListItem
